import { Info, PlaneTakeOff, SuitCase } from '@assets/icons';
import STATIC_ROUTES from '@data/staticRoutes.json';

export const ONLINE_TRANSACTION_LINKS = [
  {
    id: 0,
    href: STATIC_ROUTES.travels,
    title: 'Seyahatlerim',
    icon: SuitCase,
  },
  {
    id: 1,
    href: STATIC_ROUTES.flightStatus,
    title: 'Uçuş Durumu',
    icon: PlaneTakeOff,
  },
  {
    id: 2,
    href: STATIC_ROUTES.viewETicket,
    title: 'E-bilet Görüntüleyin',
    icon: Info,
  },
];
